import { ICombinedSection, IListData, ITodo, ITodoCount } from '../planner-interfaces';

const getTodoCountWithNested = (todo: ITodo) : number => {
    if(!todo) return null;

    let count = 1;

    if(!todo.nested) return count;

    for(const nested of todo.nested) {
        count += getTodoCountWithNested(nested);
    }

    return count;
};

export const getCombinedProjectCounts = (combinedProject: IListData|null) : ITodoCount => {
    let rootTodosCount = 0;
    let totalTodosCount = 0;

    if(!combinedProject?.projects) {
        return {
            rootTodosCount,
            totalTodosCount,
        }
    }

    for(const project of combinedProject.projects) {
        totalTodosCount += project.todosCount;

        if(!project.sections) continue;
        for(const section of project.sections) {
            rootTodosCount += section.todos.length;
        }
    }

    return {
        rootTodosCount,
        totalTodosCount,
    };
};

export const getSectionTodosCount = (combinedSection: ICombinedSection) : ITodoCount => {
    let rootTodosCount = 0;
    let totalTodosCount = 0;

    if(!combinedSection?.todos) {
        return {
            rootTodosCount,
            totalTodosCount,
        }
    }

    rootTodosCount = combinedSection.todos.length;

    for(const todo of combinedSection.todos) {
        totalTodosCount += getTodoCountWithNested(todo);
    }

    return {
        rootTodosCount,
        totalTodosCount,
    };
};
